import { Button, Drawer, Group } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { IconMessage } from '@tabler/icons-react'
import { FormattedMessage, useIntl } from 'react-intl'
import { ZOHO_FEEDBACK_FORM_URL } from '@/config/main'
import { showToast } from '@/theme/notifications'
import { ZohoEmbeddedForm } from '../ZohoEmbeddedForm'

export const FeedbackButton = () => {
  const intl = useIntl()

  const [
    isFeedbackFormOpened,
    { open: openFeedbackForm, close: closeFeedbackForm }
  ] = useDisclosure(false)

  const handleZohoFormSubmit = () => {
    showToast(intl.formatMessage({ id: 'general.feedback.success' }), 'success')

    closeFeedbackForm()
  }

  return (
    <>
      <Button
        color="brand-primary.4"
        size="xs"
        leftSection={<IconMessage size={16} />}
        fullWidth
        onClick={openFeedbackForm}
      >
        <FormattedMessage id="general.feedback.button" />
      </Button>

      <Drawer
        size="60rem"
        position="right"
        title={
          <Group wrap="nowrap" align="center" gap="xs">
            <IconMessage size={24} />
            <FormattedMessage id="general.feedback.button" />
          </Group>
        }
        opened={isFeedbackFormOpened}
        onClose={closeFeedbackForm}
      >
        {isFeedbackFormOpened && (
          <ZohoEmbeddedForm
            formUrl={ZOHO_FEEDBACK_FORM_URL}
            onSubmit={handleZohoFormSubmit}
          />
        )}
      </Drawer>
    </>
  )
}
